













































































































































































































import { defineComponent } from "vue";
import RefundInvoiceAdviser from "../RefundInvoiceAdviser.vue";
import RefundAttentionAdviser from "../RefundAttentionAdviser.vue";
import RefundInvoiceAdviserDigital from "../RefundInvoiceAdviserDigital.vue";
import IconRow from "@/components/Atoms/icon-row.vue";
import EmphasysRow from "@/components/Atoms/emphasys-row.vue";

export default defineComponent({
  components: {
    RefundInvoiceAdviser,
    RefundAttentionAdviser,
    IconRow,
    EmphasysRow,
    RefundInvoiceAdviserDigital
  }
});
